// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@tps/MobiusOverrides/TextField/TextField";
import { editCardModalStyles } from "@tps/Overrides/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

editCardModalStyles.address1TextField = {
    ...editCardModalStyles.address1TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address2TextField = {
    ...editCardModalStyles.address2TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address3TextField = {
    ...editCardModalStyles.address3TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address4TextField = {
    ...editCardModalStyles.address4TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.cityTextField = {
    ...editCardModalStyles.cityTextField,
    type: "city",
} as TextFieldProps;

editCardModalStyles.postalCodeTextField = {
    ...editCardModalStyles.postalCodeTextField,
    type: "postalCode",
} as TextFieldProps;
editCardModalStyles.editCardModal = {
    sizeVariant: "large",
};

editCardModalStyles.bottomGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &::before {
                width: calc(100% - 32px);
            }
        `,
    }),
};
editCardModalStyles.buttonsHidden = {
    ...mergeWithCss(editCardModalStyles.buttonsHidden, {
        css: css`
            justify-content: space-between;
        `,
    }),
};

editCardModalStyles.notifyError = {
    css: css`
        margin-bottom: 0;
        align-self: flex-start;
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }
    `,
};
editCardModalStyles.notifyErrorWrapper = {
    css: css`
        padding: 10px;
    `,
};
